// Reason.js
import React from "react";
import "./Reason.css";

const Reason = () => {
  return (
    <div className="Reasons" id="reasons">
      <div className="solutions-box">
        <p className="solutions-para">
          All our paid products, <span className="highlight">Rodhak Lite</span>{" "}
          and <span className="highlight">Rodhak Super</span>, are fully
          customizable to align with your requirements. Tailor the features and
          functionalities to suit your preferences and optimize your road safety
          efforts. We understand that each individual and business has unique
          needs, and our goal is to provide you with the flexibility to create a
          solution that works best for you.
        </p>
      </div>
    </div>
  );
};

export default Reason;
